<template>
  <span class="inventory-status">
    <bx-tag v-if="canceled" color="yellow">{{
      $t("lang.inventory.box_status.label_canceled")
    }}</bx-tag>
    <bx-tag v-else-if="!status" color="red">{{
      $t("lang.inventory.box_status.label_pending")
    }}</bx-tag>
    <bx-tag v-else color="green">{{
      $t("lang.inventory.box_status.label_validated")
    }}</bx-tag>
  </span>
</template>
<script>
export default {
  name: "bx-inventory-status",
  props: {
    status: {
      type: [Boolean],
      default: false
    },
    canceled: {
      type: [Boolean],
      default: false
    }
  }
};
</script>
